import { jsxs, jsx } from 'react/jsx-runtime';
import injector_a9ab7c9e from '@clover-util/inject-css';
import cx from 'clsx';
import * as React from 'react';
import { createContext, useContext, useRef, useState, useEffect } from 'react';
import YouTube from 'react-youtube';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var css$a = ".VideoPlayer_module_videoPlayer__0e1b53a826b9eb97 button{background-color:transparent;border:none;cursor:pointer;margin:0;line-height:0}.VideoPlayer_module_videoPlayer__0e1b53a826b9eb97{display:flex;height:100%;width:100%;--default-aspect-ratio:16/9;--play-button-color:#f9f9f9;--pause-button-color:#280;--loading-video-image:url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMDEiIGhlaWdodD0iMjAxIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIKICBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjUgNTApIj4KICAgIDxjaXJjbGUgcj0iNCIgZmlsbD0iIzRiNCI+CiAgICAgIDxhbmltYXRlVHJhbnNmb3JtIGF0dHJpYnV0ZU5hbWU9InRyYW5zZm9ybSIgdHlwZT0ic2NhbGUiIGJlZ2luPSItMC40MTY2NjY2NjY2NjY2NjY2M3MiCiAgICAgICAgY2FsY01vZGU9InNwbGluZSIga2V5U3BsaW5lcz0iMC4zIDAgMC43IDE7MC4zIDAgMC43IDEiIHZhbHVlcz0iMDsxOzAiIGtleVRpbWVzPSIwOzAuNTsxIgogICAgICAgIGR1cj0iMS4yNXMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogICAgPC9jaXJjbGU+CiAgPC9nPgogIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUwIDUwKSI+CiAgICA8Y2lyY2xlIHI9IjQiIGZpbGw9IiM0YjQiPgogICAgICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InNjYWxlIiBiZWdpbj0iLTAuMjA4MzMzMzMzMzMzMzMzMzFzIgogICAgICAgIGNhbGNNb2RlPSJzcGxpbmUiIGtleVNwbGluZXM9IjAuMyAwIDAuNyAxOzAuMyAwIDAuNyAxIiB2YWx1ZXM9IjA7MTswIiBrZXlUaW1lcz0iMDswLjU7MSIKICAgICAgICBkdXI9IjEuMjVzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgLz4KICAgIDwvY2lyY2xlPgogIDwvZz4KICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3NSA1MCkiPgogICAgPGNpcmNsZSByPSI0IiBmaWxsPSIjNGI0Ij4KICAgICAgPGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJzY2FsZSIgYmVnaW49IjBzIiBjYWxjTW9kZT0ic3BsaW5lIgogICAgICAgIGtleVNwbGluZXM9IjAuMyAwIDAuNyAxOzAuMyAwIDAuNyAxIiB2YWx1ZXM9IjA7MTswIiBrZXlUaW1lcz0iMDswLjU7MSIgZHVyPSIxLjI1cyIKICAgICAgICByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgLz4KICAgIDwvY2lyY2xlPgogIDwvZz4KPC9zdmc+Cg==\");--loading-background-color:#000;--overlay-controls-color:#b6fb6f;--video-player-inline-controls-color:#280;--video-player-inline-margin:0;--video-player-inline-overlay:0px;--video-player-inline-overplayer:16px;--video-player-border-radius:16px;--video-control-track-time:#000;--video-control-track-timefont--size:12px;--video-track-color:#040;--video-track-background-color:rgba(120,120,128,0.32);--modal-bg-color:#fff;--modal-zindex:9007199254740991;--video-settings-background-color:#f9f9f9;--video-settings-font-color:#040;--video-settings-options-overlay:rgba(0,0,0,0.5);--video-settings-back-button-color-off:rgba(0,0,0,0.05);--video-settings-back-button-color-on:rgba(0,0,0,0.25);--video-settings-border-radius:8px;--video-control-font-size:12px;--video-control-font-eyebrow-color:#040;--video-control-font-eyebrow-size:10px}.VideoPlayer_module_videoPlayer__0e1b53a826b9eb97.VideoPlayer_module_green__0e1b53a826b9eb97{--modal-bg-color:#040;--play-button-color:#b6fb6f;--video-player-inline-controls-color:#f9f9f9;--video-control-track-time:#b6fb6f;--video-track-color:#fff;--pause-button-color:#b6fb6f;--video-control-font-eyebrow-color:#b6fb6f;--video-settings-background-color:#040;--video-settings-font-color:#f9f9f9}.VideoPlayer_module_videoPlayer__0e1b53a826b9eb97.VideoPlayer_module_purple__0e1b53a826b9eb97{--modal-bg-color:#442255;--play-button-color:#ccbbff;--overlay-controls-color:#ccbbff;--video-player-inline-controls-color:#f9f9f9;--video-control-font-eyebrow-color:#f9f9f9;--video-control-track-time:#ccbbff;--video-track-color:#f9f9f9;--pause-button-color:#ccbbff;--video-settings-background-color:#442255;--video-settings-font-color:#f9f9f9}.VideoPlayer_module_videoPlayer__0e1b53a826b9eb97.VideoPlayer_module_white__0e1b53a826b9eb97{--modal-bg-color:rgba(0,0,0,0.6);--play-button-color:#f9f9f9;--overlay-controls-color:#f9f9f9;--video-player-inline-controls-color:#f9f9f9;--video-control-font-eyebrow-color:#f9f9f9;--video-control-track-time:#f9f9f9;--video-track-color:#f9f9f9;--pause-button-color:#f9f9f9;--video-settings-background-color:#000;--video-settings-font-color:#f9f9f9}";
var modules_7d7d7f29 = {"videoPlayer":"VideoPlayer_module_videoPlayer__0e1b53a826b9eb97","green":"VideoPlayer_module_green__0e1b53a826b9eb97","purple":"VideoPlayer_module_purple__0e1b53a826b9eb97","white":"VideoPlayer_module_white__0e1b53a826b9eb97"};
injector_a9ab7c9e(css$a,{"prepend":true,"attributes":{"data-package":"@clover-growth/video-player@0.8.1"}});

var css$9 = ".VideoPlayerContainer_module_videoPlayerContainer__36ebcc832fee4c0f{display:inline-flex;flex-flow:column;position:relative;width:100%}.VideoPlayerContainer_module_videoPlayerContainer__36ebcc832fee4c0f.VideoPlayerContainer_module_centered__36ebcc832fee4c0f{align-items:center}.VideoPlayerContainer_module_videoControlsContainer__36ebcc832fee4c0f{position:absolute;top:0;left:0;width:100%;height:100%;display:flex}.VideoPlayerContainer_module_videoControlsContainer__36ebcc832fee4c0f.VideoPlayerContainer_module_noPoster__36ebcc832fee4c0f{position:static}.VideoPlayerContainer_module_modal__36ebcc832fee4c0f{display:flex;position:fixed;top:0;left:0;flex-direction:column;justify-content:center;width:100vw;height:100vh;background:var(--modal-bg-color);z-index:var(--modal-zindex);padding:80px 7vw;box-sizing:border-box;cursor:pointer}";
var modules_0dd15ba7 = {"videoPlayerContainer":"VideoPlayerContainer_module_videoPlayerContainer__36ebcc832fee4c0f","centered":"VideoPlayerContainer_module_centered__36ebcc832fee4c0f","videoControlsContainer":"VideoPlayerContainer_module_videoControlsContainer__36ebcc832fee4c0f","noPoster":"VideoPlayerContainer_module_noPoster__36ebcc832fee4c0f","modal":"VideoPlayerContainer_module_modal__36ebcc832fee4c0f"};
injector_a9ab7c9e(css$9,{"prepend":true,"attributes":{"data-package":"@clover-growth/video-player@0.8.1"}});

var css$8 = ".VideoPoster_module_videoPosterContainer__68a86fec276cca2c{position:relative;border-radius:var(--video-player-border-radius);overflow:hidden}.VideoPoster_module_fixedAspectRatio__68a86fec276cca2c{min-width:100%;aspect-ratio:var(--default-aspect-ratio)}.VideoPoster_module_fixedAspectRatio__68a86fec276cca2c iframe{background-clip:padding-box}.VideoPoster_module_videoPoster__68a86fec276cca2c{display:block;width:100%;opacity:0}.VideoPoster_module_videoPoster__68a86fec276cca2c.VideoPoster_module_posterActive__68a86fec276cca2c{opacity:1}.VideoPoster_module_loadButton__68a86fec276cca2c{position:absolute;top:0;left:0;width:100%;height:100%;background-color:transparent}.VideoPoster_module_loadButtonIcon__68a86fec276cca2c{position:absolute;bottom:16px;left:16px;color:var(--play-button-color);margin:var(--video-player-inline-margin)}";
var modules_8b7799a9 = {"videoPosterContainer":"VideoPoster_module_videoPosterContainer__68a86fec276cca2c","fixedAspectRatio":"VideoPoster_module_fixedAspectRatio__68a86fec276cca2c","videoPoster":"VideoPoster_module_videoPoster__68a86fec276cca2c","posterActive":"VideoPoster_module_posterActive__68a86fec276cca2c","loadButton":"VideoPoster_module_loadButton__68a86fec276cca2c","loadButtonIcon":"VideoPoster_module_loadButtonIcon__68a86fec276cca2c"};
injector_a9ab7c9e(css$8,{"prepend":true,"attributes":{"data-package":"@clover-growth/video-player@0.8.1"}});

var _path$9;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20m0-4a16 16 0 1 0 0-32 16 16 0 0 0 0 32m-2.756-23.17 9.758 6.504a.8.8 0 0 1 0 1.332l-9.76 6.504A.8.8 0 0 1 16 26.506V13.494a.8.8 0 0 1 1.244-.664"
  })));
};

var VideoPoster = function (_a) {
    var _b;
    var posterUrl = _a.posterUrl, visible = _a.visible, className = _a.className, children = _a.children, handlePlayVideo = _a.handlePlayVideo, playerType = _a.playerType;
    var posterClasses = cx(modules_8b7799a9.videoPoster, (_b = {},
        _b[modules_8b7799a9.posterActive] = visible,
        _b));
    return (jsxs("div", __assign({ className: cx(modules_8b7799a9.videoPosterContainer, playerType === 'youtube' && modules_8b7799a9.fixedAspectRatio, playerType === 'vimeo' && modules_8b7799a9.fixedAspectRatio, playerType === 'native' && !Boolean(posterUrl) && modules_8b7799a9.fixedAspectRatio, className) }, { children: [posterUrl && jsx("img", { src: posterUrl, className: posterClasses, alt: "" }), !visible && children, visible && (jsx("button", __assign({ "aria-label": 'Play Button', className: modules_8b7799a9.loadButton, onClick: handlePlayVideo }, { children: jsx(SvgPlay, { width: 26, height: 26, className: modules_8b7799a9.loadButtonIcon }) })))] })));
};

var css$7 = ".NativeVideoPlayer_module_video__bf7e759e8db74586{width:100%;height:100%;background:var(--loading-background-color) var(--loading-video-image) no-repeat;background-position:center;border-radius:var(--video-player-border-radius)}.NativeVideoPlayer_module_video__bf7e759e8db74586::-internal-media-controls-overlay-cast-button{display:none}.NativeVideoPlayer_module_loaded__bf7e759e8db74586{background-color:transparent}";
var modules_2731024e = {"video":"NativeVideoPlayer_module_video__bf7e759e8db74586","loaded":"NativeVideoPlayer_module_loaded__bf7e759e8db74586"};
injector_a9ab7c9e(css$7,{"prepend":true,"attributes":{"data-package":"@clover-growth/video-player@0.8.1"}});

var initialVideoContext = {
    isPlaying: false,
    setIsPlaying: function () { return undefined; },
    isLoaded: false,
    setIsLoaded: function () { return undefined; },
    isFullscreen: false,
    setIsFullscreen: function () { return undefined; },
    playbackState: {
        time: 0,
        duration: 0,
        remaining: 0,
    },
    setPlaybackState: function () { return undefined; },
    seekTime: null,
    setSeekTime: function () { return undefined; },
    isSettingsPanelOpen: false,
    setIsSettingsPanelOpen: function () { return undefined; },
    isPictureInPictureEnabled: false,
    setIsPictureInPictureEnabled: function () { return undefined; },
    playbackSpeed: 1,
    setPlaybackSpeed: function () { return undefined; },
    setFeaturesSupported: function () { return undefined; },
    featuresSupported: {
        pictureInPicture: false,
        fullscreen: false,
        overlayControls: false,
        inlineControls: false,
    },
    isMuted: false,
    setIsMuted: function () { return undefined; },
};
var VideoContext = createContext(initialVideoContext);

var useVideoPlayer = function () { return useContext(VideoContext); };

var NativeVideoPlayer = function (_a) {
    var url = _a.url, _b = _a.autoplay, autoplay = _b === void 0 ? false : _b, onEnded = _a.onEnded;
    var _c = useVideoPlayer(), isPlaying = _c.isPlaying, isFullscreen = _c.isFullscreen, setIsFullscreen = _c.setIsFullscreen, setPlaybackState = _c.setPlaybackState, seekTime = _c.seekTime, playbackSpeed = _c.playbackSpeed, isPictureInPictureEnabled = _c.isPictureInPictureEnabled, setFeaturesSupported = _c.setFeaturesSupported, isMuted = _c.isMuted, setIsLoaded = _c.setIsLoaded, setSeekTime = _c.setSeekTime;
    var videoRef = useRef(null);
    var _d = useState(false), isReady = _d[0], setIsReady = _d[1];
    useEffect(function initializeVideoEvents() {
        var _a, _b, _c;
        var playEvent = function () { return setIsLoaded(true); };
        var loadEvent = function () { return setIsReady(true); };
        var endedEvent = function () {
            setSeekTime(0);
            setIsLoaded(false);
            onEnded && onEnded();
        };
        (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('play', playEvent);
        (_b = videoRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('ended', endedEvent);
        (_c = videoRef.current) === null || _c === void 0 ? void 0 : _c.addEventListener('loadeddata', loadEvent);
        return function () {
            var _a, _b, _c;
            (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('play', playEvent);
            (_b = videoRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('ended', playEvent);
            (_c = videoRef.current) === null || _c === void 0 ? void 0 : _c.removeEventListener('loadeddata', loadEvent);
        };
    }, []);
    useEffect(function initializeFeaturesSupported() {
        setFeaturesSupported({
            pictureInPicture: Boolean(document.pictureInPictureEnabled),
            fullscreen: Boolean(document.fullscreenEnabled),
            overlayControls: true,
            inlineControls: true,
        });
    }, []);
    useEffect(function togglePlayPause() {
        if (!videoRef.current)
            return;
        if (isPlaying && videoRef.current.paused) {
            videoRef.current.play();
        }
        else if (!isPlaying && !videoRef.current.paused) {
            videoRef.current.pause();
        }
    }, [isPlaying, videoRef.current]);
    useEffect(function toggleFullScreen() {
        if (!videoRef.current)
            return;
        var updateFullscreenState = function () {
            setIsFullscreen(document.fullscreenElement !== null);
        };
        if (isFullscreen) {
            videoRef.current.requestFullscreen();
            videoRef.current.addEventListener('fullscreenchange', updateFullscreenState);
        }
        return function () {
            var _a;
            document.fullscreenElement && document.exitFullscreen();
            (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('fullscreenchange', updateFullscreenState);
        };
    }, [isFullscreen, videoRef.current]);
    useEffect(function handleTimeUpdate() {
        if (!videoRef.current)
            return;
        var updatePlaybackState = function () {
            if (!videoRef.current)
                return;
            var time = videoRef.current.currentTime;
            var duration = videoRef.current.duration;
            var remaining = duration - time;
            setPlaybackState({ time: time, duration: duration, remaining: remaining });
        };
        videoRef.current.addEventListener('timeupdate', updatePlaybackState);
        return function () {
            var _a;
            (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('timeupdate', updatePlaybackState);
        };
    }, [videoRef.current]);
    useEffect(function handleSeekTimeChanges() {
        if (!videoRef.current || !seekTime)
            return;
        videoRef.current.currentTime = seekTime;
    }, [seekTime, videoRef.current]);
    useEffect(function handlePlaybackChanges() {
        if (!videoRef.current || isNaN(playbackSpeed))
            return;
        videoRef.current.playbackRate = playbackSpeed;
    }, [playbackSpeed, videoRef.current]);
    useEffect(function handlePictureInPicture() {
        if (!videoRef.current || !document.pictureInPictureEnabled)
            return;
        if (isPictureInPictureEnabled && !document.pictureInPictureElement) {
            videoRef.current.requestPictureInPicture();
        }
        else if (!isPictureInPictureEnabled && document.pictureInPictureElement) {
            document.exitPictureInPicture();
        }
    }, [isPictureInPictureEnabled, videoRef.current]);
    useEffect(function toggleMute() {
        if (!videoRef.current)
            return;
        videoRef.current.muted = isMuted;
    }, [isMuted, videoRef.current]);
    return (jsx("video", __assign({ ref: videoRef, autoPlay: autoplay, tabIndex: 0, className: cx(modules_2731024e.video, isReady && modules_2731024e.loaded) }, { children: jsx("source", { src: url }) })));
};

var css$6 = ".OverlayControls_module_overlayControls__3ee6b80de28f6097{display:flex;position:absolute;top:0;left:0;align-items:flex-end;width:100%;height:100%;cursor:pointer;margin:var(--video-player-inline-overlay);width:calc(100% - var(--video-player-inline-overlay) * 2)}.OverlayControls_module_volumeButton__3ee6b80de28f6097{position:absolute;top:24px;left:24px;color:var(--overlay-controls-color);cursor:pointer}.OverlayControls_module_closeButton__3ee6b80de28f6097{position:absolute;top:24px;right:24px;color:var(--overlay-controls-color)}";
var modules_4111da4c = {"overlayControls":"OverlayControls_module_overlayControls__3ee6b80de28f6097","volumeButton":"OverlayControls_module_volumeButton__3ee6b80de28f6097","closeButton":"OverlayControls_module_closeButton__3ee6b80de28f6097"};
injector_a9ab7c9e(css$6,{"prepend":true,"attributes":{"data-package":"@clover-growth/video-player@0.8.1"}});

var _path$8;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.343 18.988c-.45.45-.464 1.219 0 1.67.463.45 1.231.45 1.682 0L10.5 12.18l8.476 8.477c.45.45 1.231.464 1.681 0 .45-.463.45-1.218 0-1.669l-8.475-8.49 8.475-8.476c.45-.45.464-1.219 0-1.67-.463-.463-1.231-.463-1.681 0L10.5 8.83 2.025.353C1.575-.111.793-.124.343.353c-.45.463-.45 1.218 0 1.669l8.475 8.476z"
  })));
};

var _path$7;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var SvgVolumeOn = function SvgVolumeOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 25 20"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.773 19.25c.806 0 1.397-.602 1.397-1.396V1.45c0-.805-.59-1.45-1.418-1.45-.548 0-.935.236-1.525.795l-4.49 4.2a.34.34 0 0 1-.248.097H2.45C.86 5.092 0 5.972 0 7.638v3.996c0 1.665.86 2.546 2.45 2.546h3.04c.096 0 .171.032.246.096l4.49 4.233c.538.515.989.741 1.547.741m9.55-1.966c.494.301 1.096.194 1.44-.311 1.396-1.977 2.213-4.63 2.213-7.359s-.806-5.392-2.213-7.358c-.344-.505-.946-.623-1.44-.312-.515.323-.59.967-.204 1.536 1.139 1.676 1.794 3.857 1.794 6.134 0 2.267-.666 4.448-1.794 6.134-.376.57-.311 1.203.204 1.536m-4.318-2.879a1.01 1.01 0 0 0 1.396-.279c.87-1.16 1.386-2.804 1.386-4.512s-.515-3.34-1.386-4.511c-.333-.473-.934-.58-1.396-.269-.526.344-.634.978-.204 1.6.59.85.924 1.988.924 3.18s-.344 2.32-.924 3.18c-.42.623-.322 1.257.204 1.611"
  })));
};

var _path$6;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var SvgVolumeOff = function SvgVolumeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.773 19.25c.806 0 1.397-.602 1.397-1.396V1.45c0-.805-.59-1.45-1.418-1.45-.548 0-.935.236-1.525.795l-4.49 4.2a.34.34 0 0 1-.248.097H2.45C.86 5.092 0 5.972 0 7.638v3.996c0 1.665.86 2.546 2.45 2.546h3.04c.096 0 .171.032.246.096l4.49 4.233c.538.515.989.741 1.547.741"
  })));
};

var OverlayControls = function (_a) {
    var _b = _a.showCloseButton, showCloseButton = _b === void 0 ? true : _b;
    var _c = useVideoPlayer(), setIsLoaded = _c.setIsLoaded, isPlaying = _c.isPlaying, setIsPlaying = _c.setIsPlaying, isMuted = _c.isMuted, setIsMuted = _c.setIsMuted;
    var toggleMute = function (event) {
        event.stopPropagation();
        setIsMuted(!isMuted);
    };
    var pauseAndClose = function () {
        setIsPlaying(false);
        setIsLoaded(false);
    };
    var togglePlay = function () {
        setIsPlaying(!isPlaying);
    };
    return (jsxs("div", __assign({ className: modules_4111da4c.overlayControls, onClick: togglePlay, role: "presentation" }, { children: [jsx("button", __assign({ "aria-label": 'Toggle Mute', className: modules_4111da4c.volumeButton, onClick: toggleMute }, { children: isMuted ?
                    jsx(SvgVolumeOff, { width: 21, height: 21 }) :
                    jsx(SvgVolumeOn, { width: 25, height: 20 }) })), showCloseButton &&
                jsx("button", __assign({ "aria-label": 'Close Player', className: modules_4111da4c.closeButton, onClick: pauseAndClose }, { children: jsx(SvgClose, { width: 21, height: 21 }) }))] })));
};

var css$5 = ".InlineControls_module_container__5ece63e5a19652e2{margin-top:32px;color:var(--video-player-inline-controls-color);box-sizing:border-box}.InlineControls_module_container__5ece63e5a19652e2.InlineControls_module_overPlayer__5ece63e5a19652e2{position:absolute;width:100%;bottom:0;left:0;background:linear-gradient(to top,rgba(0,0,0,0.6),rgba(0,0,0,0));border-radius:var(--video-player-border-radius);padding:var(--video-player-inline-overplayer)}.InlineControls_module_actions__5ece63e5a19652e2{position:relative;display:flex;justify-content:space-between;-moz-column-gap:16px;column-gap:16px}.InlineControls_module_playButton__5ece63e5a19652e2{color:var(--pause-button-color);padding:0}.InlineControls_module_secondaryButton__5ece63e5a19652e2{color:currentColor;padding:0}";
var modules_9d071b87 = {"container":"InlineControls_module_container__5ece63e5a19652e2","overPlayer":"InlineControls_module_overPlayer__5ece63e5a19652e2","actions":"InlineControls_module_actions__5ece63e5a19652e2","playButton":"InlineControls_module_playButton__5ece63e5a19652e2","secondaryButton":"InlineControls_module_secondaryButton__5ece63e5a19652e2"};
injector_a9ab7c9e(css$5,{"prepend":true,"attributes":{"data-package":"@clover-growth/video-player@0.8.1"}});

var _path$5;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20m0-4a16 16 0 1 0 0-32 16 16 0 0 0 0 32m-6-22h4v12h-4zm8 0h4v12h-4z"
  })));
};

var _g;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgFullscreen = function SvgFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.024 1.994H2.006v5.523H0V0h8.024zM10.003 15.008h6.018V9.51h1.98v7.49h-7.998zM16.021 7.517V1.994h-6.018V0H18v7.517zM2.006 9.511v5.497h6.018v1.994H0v-7.49z"
  }))));
};

var _path$4;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 16c4.377 0 8-3.631 8-8 0-4.376-3.631-8-8.008-8C3.624 0 0 3.624 0 8c0 4.369 3.631 8 8 8m0-1.333A6.634 6.634 0 0 1 1.341 8a6.63 6.63 0 0 1 6.651-6.667A6.653 6.653 0 0 1 14.667 8 6.636 6.636 0 0 1 8 14.667m-3.663-5.53a1.14 1.14 0 0 0 1.138-1.145c0-.627-.518-1.137-1.138-1.137a1.141 1.141 0 1 0 0 2.282m3.655 0c.628 0 1.145-.51 1.145-1.145a1.145 1.145 0 0 0-2.29 0c0 .635.518 1.145 1.145 1.145m3.663 0a1.14 1.14 0 0 0 1.137-1.145c0-.627-.51-1.137-1.137-1.137a1.141 1.141 0 1 0 0 2.282"
  })));
};

var formatTime = function (totalSeconds) {
    var roundedSeconds = Math.floor(totalSeconds);
    var secondsInHour = 3600;
    var secondsInMinute = 60;
    var hours = Math.floor(roundedSeconds / secondsInHour);
    var minutes = Math.floor((roundedSeconds % secondsInHour) / secondsInMinute);
    var seconds = roundedSeconds % secondsInMinute;
    var hoursString = hours.toString().padStart(2, '0');
    var minutesString = minutes.toString().padStart(2, '0');
    var secondsString = seconds.toString().padStart(2, '0');
    return "".concat(hoursString, ":").concat(minutesString, ":").concat(secondsString);
};
var generateID = function (label, value) {
    var prefix = 'video-setting-';
    var slugifiedLabel = label.replace(/\W/g, '-').toLowerCase();
    if (!value)
        return "".concat(prefix).concat(slugifiedLabel);
    var slugifiedValue = value.replace(/\W/g, '-').toLowerCase();
    return "".concat(prefix).concat(slugifiedLabel, "-").concat(slugifiedValue);
};
var getYouTubeIdFromUrl = function (url) {
    var youTubeRegExp = /^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/;
    var match = RegExp(youTubeRegExp).exec(url);
    if (!match)
        throw new Error("Cannot find YouTube ID with URL ".concat(url));
    return match[2];
};
var getVimeoIdFromUrl = function (url) {
    var vimeoRegExp = /^.*(vimeo\.com\/|video\/)(\d+).*/;
    var match = RegExp(vimeoRegExp).exec(url);
    if (!match)
        throw new Error("Cannot find Vimeo ID with URL ".concat(url));
    return match[2];
};
var isValidUrl = function (url) {
    try {
        return Boolean(new URL(url));
    }
    catch (e) {
        return false;
    }
};

var css$4 = ".TimeTrack_module_trackContainer__7c6b739c82c1bbb1{padding:8px 0;cursor:pointer}.TimeTrack_module_totalTimeBar__7c6b739c82c1bbb1{width:100%;height:5px;border-radius:16px;background:var(--video-track-background-color);overflow:hidden}.TimeTrack_module_currentTime__7c6b739c82c1bbb1{width:0;width:var(--current-time,0);height:100%;transition:width 250ms linear;background:var(--video-track-color)}.TimeTrack_module_trackTime__7c6b739c82c1bbb1{display:flex;justify-content:space-between;color:var(--video-control-track-time);font-size:var(--video-control-track-timefont--size)}";
var modules_2c1ad498 = {"trackContainer":"TimeTrack_module_trackContainer__7c6b739c82c1bbb1","totalTimeBar":"TimeTrack_module_totalTimeBar__7c6b739c82c1bbb1","currentTime":"TimeTrack_module_currentTime__7c6b739c82c1bbb1","trackTime":"TimeTrack_module_trackTime__7c6b739c82c1bbb1"};
injector_a9ab7c9e(css$4,{"prepend":true,"attributes":{"data-package":"@clover-growth/video-player@0.8.1"}});

var TimeTrack = function () {
    var _a = useVideoPlayer(), playbackState = _a.playbackState, setSeekTime = _a.setSeekTime;
    var _b = playbackState.time, time = _b === void 0 ? 0 : _b, duration = playbackState.duration, remaining = playbackState.remaining;
    var currentTimeStyles = {
        '--current-time': "".concat(Math.round((time / duration) * 10000) / 100, "%"),
    };
    var handleTrackClick = function (event) {
        if (!event.currentTarget)
            return;
        var trackContainer = event.currentTarget;
        var elWidth = trackContainer.clientWidth;
        var offsetX = event.nativeEvent.offsetX || event.clientX;
        var timePercentage = offsetX / elWidth;
        var newTime = playbackState.duration * timePercentage;
        setSeekTime(newTime);
    };
    return (jsxs("div", { children: [jsx("div", __assign({ className: modules_2c1ad498.trackContainer, onClick: handleTrackClick }, { children: jsx("div", __assign({ className: modules_2c1ad498.totalTimeBar }, { children: jsx("div", { className: modules_2c1ad498.currentTime, style: currentTimeStyles }) })) })), jsxs("div", __assign({ className: modules_2c1ad498.trackTime }, { children: [jsx("span", { children: formatTime(time) }), jsxs("span", { children: ["-", formatTime(remaining)] })] }))] }));
};

var css$3 = ".VideoSettingsPanel_module_videoSettingsContainer__849de006fde3f73f{position:absolute;right:0;bottom:32px}.VideoSettingsPanel_module_videoSettings__849de006fde3f73f{width:-moz-max-content;width:max-content;border-radius:var(--video-settings-border-radius);overflow:hidden;background-color:var(--video-settings-background-color)}.VideoSettingsPanel_module_settingButton__849de006fde3f73f{display:flex;flex-direction:row;-moz-column-gap:12px;column-gap:12px;align-items:center;padding:16px;width:100%;font-size:var(--video-control-font-size);font-weight:var(--video-control-font-weigh);line-height:normal;color:var(--video-settings-font-color)}.VideoSettingsPanel_module_settingButton__849de006fde3f73f:hover{background-color:var(--video-settings-back-button-color-on)}";
var modules_751eef56 = {"videoSettingsContainer":"VideoSettingsPanel_module_videoSettingsContainer__849de006fde3f73f","videoSettings":"VideoSettingsPanel_module_videoSettings__849de006fde3f73f","settingButton":"VideoSettingsPanel_module_settingButton__849de006fde3f73f"};
injector_a9ab7c9e(css$3,{"prepend":true,"attributes":{"data-package":"@clover-growth/video-player@0.8.1"}});

var _rect, _path$3;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgPip = function SvgPip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 15"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 14,
    x: 0.5,
    y: 0.5,
    fill: "transparent",
    stroke: "currentColor",
    rx: 1.5
  })), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 6h9v5H6z"
  })));
};

var _path$2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgSpeed = function SvgSpeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.88.018v1.803a7.207 7.207 0 0 1 6.279 8.04c-.415 3.28-2.995 5.885-6.28 6.273v1.802c4.963-.496 8.572-4.894 8.075-9.851C17.548 3.804 14.147.424 9.88 0zM3.265 15.962A9 9 0 0 0 8.075 18v-1.802a7.2 7.2 0 0 1-3.519-1.47zm1.29-12.618A7.2 7.2 0 0 1 8.075 1.83V.027A8.87 8.87 0 0 0 3.266 2.01zM3.284 4.57l-1.29-1.29A8.9 8.9 0 0 0 0 8.086h1.804a7.2 7.2 0 0 1 1.48-3.515m-1.47 5.317H.008a9.04 9.04 0 0 0 1.994 4.804l1.281-1.289a7.2 7.2 0 0 1-1.47-3.515m5.359 3.155 5.413-4.056L7.173 4.93z"
  })));
};

var css$2 = ".VideoSettingOptionsButton_module_optionsContainer__58ffc50abe92154b{position:absolute;top:0;right:0;min-width:100%;min-height:100%;border-radius:var(--video-settings-border-radius);color:var(--video-settings-font-color);font-size:var(--video-control-font-size)}.VideoSettingOptionsButton_module_optionsContainer__58ffc50abe92154b::before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background:var(--video-settings-options-overlay);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);border-radius:var(--video-settings-border-radius)}.VideoSettingOptionsButton_module_optionsGroup__58ffc50abe92154b{position:relative;display:flex;flex-direction:column;border-radius:var(--video-settings-border-radius);background:var(--video-settings-background-color)}.VideoSettingOptionsButton_module_optionsHeader__58ffc50abe92154b{display:flex;align-items:center;justify-content:space-between}.VideoSettingOptionsButton_module_backButton__58ffc50abe92154b{display:flex;align-items:center;padding:12px;border-bottom-right-radius:var(--video-settings-border-radius);background-color:var(--video-settings-back-button-color-off);color:inherit;cursor:pointer}.VideoSettingOptionsButton_module_backButton__58ffc50abe92154b:hover{background:var(--video-settings-back-button-color-on)}.VideoSettingOptionsButton_module_backButton__58ffc50abe92154b > :first-child{margin-right:8px}.VideoSettingOptionsButton_module_optionValue__58ffc50abe92154b{padding:12px;color:var(--video-control-font-eyebrow-color);font-size:var(--video-control-font-eyebrow-size)}.VideoSettingOptionsButton_module_selectedValue__58ffc50abe92154b{font-size:var(--video-control-font-eyebrow-size)}.VideoSettingOptionsButton_module_optionsList__58ffc50abe92154b{display:flex;justify-content:space-between;padding:12px}.VideoSettingOptionsButton_module_option__58ffc50abe92154b{display:flex;flex-direction:column;align-items:center;padding:0 8px;cursor:pointer}.VideoSettingOptionsButton_module_option__58ffc50abe92154b label{margin-bottom:6px;color:inherit;font-size:inherit;line-height:inherit;cursor:inherit}.VideoSettingOptionsButton_module_option__58ffc50abe92154b .VideoSettingOptionsButton_module_input__58ffc50abe92154b{width:5px;height:5px;background:transparent;cursor:inherit;-webkit-appearance:none;-moz-appearance:none;appearance:none}.VideoSettingOptionsButton_module_option__58ffc50abe92154b .VideoSettingOptionsButton_module_input__58ffc50abe92154b:checked{border-radius:100%;background:var(--video-control-font-eyebrow-color)}";
var modules_09d63212 = {"optionsContainer":"VideoSettingOptionsButton_module_optionsContainer__58ffc50abe92154b","optionsGroup":"VideoSettingOptionsButton_module_optionsGroup__58ffc50abe92154b","optionsHeader":"VideoSettingOptionsButton_module_optionsHeader__58ffc50abe92154b","backButton":"VideoSettingOptionsButton_module_backButton__58ffc50abe92154b","optionValue":"VideoSettingOptionsButton_module_optionValue__58ffc50abe92154b","selectedValue":"VideoSettingOptionsButton_module_selectedValue__58ffc50abe92154b","optionsList":"VideoSettingOptionsButton_module_optionsList__58ffc50abe92154b","option":"VideoSettingOptionsButton_module_option__58ffc50abe92154b","input":"VideoSettingOptionsButton_module_input__58ffc50abe92154b"};
injector_a9ab7c9e(css$2,{"prepend":true,"attributes":{"data-package":"@clover-growth/video-player@0.8.1"}});

var _path$1;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 6 10"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m5.333 9-4-4 4-4"
  })));
};

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 6 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m1 1 4 4-4 4"
  })));
};

var VideoSettingOptionsButton = function (_a) {
    var label = _a.label, defaultValue = _a.defaultValue, options = _a.options, onChange = _a.onChange, children = _a.children, className = _a.className;
    var _b = useState(false), isOptionsPanelVisible = _b[0], setIsOptionsPanelVisible = _b[1];
    var _c = useState(defaultValue), selectedValue = _c[0], setSelectedValue = _c[1];
    var openOptionsPanel = function (event) {
        event.stopPropagation();
        setIsOptionsPanelVisible(true);
    };
    var closeOptionsPanel = function (event) {
        event.stopPropagation();
        setIsOptionsPanelVisible(false);
    };
    var handleOnChange = function (event) {
        event.stopPropagation();
        setSelectedValue(event.currentTarget.value);
        onChange(event.currentTarget.value);
        setIsOptionsPanelVisible(false);
    };
    var selectedOption = options.find(function (o) { return o.value === selectedValue; });
    return (jsxs("button", __assign({ "aria-label": "Change ".concat(label, " settings"), className: className, onClick: openOptionsPanel }, { children: [children, jsx("span", { children: label }), jsx("span", __assign({ className: modules_09d63212.selectedValue }, { children: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label })), jsx(SvgArrowRight, { width: 6, height: 10 }), isOptionsPanelVisible && (jsx("div", __assign({ className: modules_09d63212.optionsContainer }, { children: jsxs("div", __assign({ className: modules_09d63212.optionsGroup }, { children: [jsxs("header", __assign({ className: modules_09d63212.optionsHeader }, { children: [jsxs("button", __assign({ className: modules_09d63212.backButton, onClick: closeOptionsPanel }, { children: [jsx(SvgArrowLeft, { width: 6, height: 10 }), jsx("span", { children: label })] })), jsx("span", __assign({ className: modules_09d63212.optionValue }, { children: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label }))] })), jsx("div", __assign({ className: modules_09d63212.optionsList }, { children: options.map(function (option) { return (jsxs("div", __assign({ className: modules_09d63212.option }, { children: [jsx("label", __assign({ htmlFor: generateID(label, option.value) }, { children: option.label })), jsx("input", { type: "radio", id: generateID(label, option.value), name: generateID(label), className: modules_09d63212.input, onChange: handleOnChange, checked: option.value === selectedValue, value: option.value })] }), option.value)); }) }))] })) })))] })));
};

var VideoSettingsPanel = function () {
    var _a = useVideoPlayer(), isPictureInPictureEnabled = _a.isPictureInPictureEnabled, setIsPictureInPictureEnabled = _a.setIsPictureInPictureEnabled, playbackSpeed = _a.playbackSpeed, setPlaybackSpeed = _a.setPlaybackSpeed, setIsSettingsPanelOpen = _a.setIsSettingsPanelOpen, featuresSupported = _a.featuresSupported;
    var togglePictureInPicture = function (event) {
        event.stopPropagation();
        setIsPictureInPictureEnabled(!isPictureInPictureEnabled);
        setIsSettingsPanelOpen(false);
    };
    var handlePlaybackSpeedChange = function (value) {
        setPlaybackSpeed(parseFloat(value));
    };
    return (jsx("div", __assign({ className: modules_751eef56.videoSettingsContainer }, { children: jsxs("div", __assign({ className: modules_751eef56.videoSettings }, { children: [jsx(VideoSettingOptionsButton, __assign({ className: modules_751eef56.settingButton, label: 'Playback speed', defaultValue: "".concat(playbackSpeed), options: [
                        { label: '0.5', value: '0.5' },
                        { label: '0.75', value: '0.75' },
                        { label: 'Normal', value: '1' },
                        { label: '1.25', value: '1.25' },
                        { label: '1.5', value: '1.5' },
                    ], onChange: handlePlaybackSpeedChange }, { children: jsx(SvgSpeed, { width: 18, height: 18 }) })), featuresSupported.pictureInPicture &&
                    jsxs("button", __assign({ "aria-label": 'Toggle Picture in Picture', className: modules_751eef56.settingButton, onClick: togglePictureInPicture }, { children: [jsx(SvgPip, { width: 18, height: 18 }), jsx("span", { children: "Picture in Picture" })] }))] })) })));
};

var InlineControls = function (_a) {
    var position = _a.position;
    var _b = useVideoPlayer(), isPlaying = _b.isPlaying, setIsPlaying = _b.setIsPlaying, setIsFullscreen = _b.setIsFullscreen, isSettingsPanelOpen = _b.isSettingsPanelOpen, setIsSettingsPanelOpen = _b.setIsSettingsPanelOpen, featuresSupported = _b.featuresSupported;
    var toggleSettingsPanel = function (event) {
        event.stopPropagation();
        setIsSettingsPanelOpen(!isSettingsPanelOpen);
    };
    return (jsxs("div", __assign({ className: cx(modules_9d071b87.container, position === 'over-player' && modules_9d071b87.overPlayer) }, { children: [jsxs("div", __assign({ className: modules_9d071b87.actions }, { children: [!isPlaying &&
                        jsx("button", __assign({ "aria-label": 'Play Video', onClick: function () { return setIsPlaying(true); }, className: modules_9d071b87.playButton }, { children: jsx(SvgPlay, { width: 24, height: 24 }) })), isPlaying &&
                        jsx("button", __assign({ "aria-label": 'Pause Video', onClick: function () { return setIsPlaying(false); }, className: modules_9d071b87.playButton }, { children: jsx(SvgPause, { width: 24, height: 24 }) })), jsxs("div", __assign({ className: modules_9d071b87.actions }, { children: [featuresSupported.fullscreen &&
                                jsx("button", __assign({ "aria-label": 'Full screen', onClick: function () { return setIsFullscreen(true); }, className: modules_9d071b87.secondaryButton }, { children: jsx(SvgFullscreen, { width: 24, height: 24 }) })), jsx("button", __assign({ "aria-label": 'Open Settings', onClick: toggleSettingsPanel, className: modules_9d071b87.secondaryButton }, { children: jsx(SvgSettings, { width: 24, height: 24 }) })), isSettingsPanelOpen && jsx(VideoSettingsPanel, {})] }))] })), jsx(TimeTrack, {})] })));
};

var css$1 = ".YoutubeVideoPlayer_module_video__27d99add4d188623{width:100%;height:100%;background:var(--loading-background-color) var(--loading-video-image) no-repeat;background-position:center;border-radius:var(--video-player-border-radius)}";
var modules_66d8d928 = {"video":"YoutubeVideoPlayer_module_video__27d99add4d188623"};
injector_a9ab7c9e(css$1,{"prepend":true,"attributes":{"data-package":"@clover-growth/video-player@0.8.1"}});

var YoutubeVideoPlayer = function (_a) {
    var url = _a.url, autoplay = _a.autoplay, onEnded = _a.onEnded;
    var setFeaturesSupported = useVideoPlayer().setFeaturesSupported;
    var videoId = isValidUrl(url) ? getYouTubeIdFromUrl(url) : url;
    useEffect(function initializeFeaturesSupported() {
        setFeaturesSupported({
            pictureInPicture: false,
            fullscreen: false,
            overlayControls: false,
            inlineControls: false,
        });
    }, []);
    return (jsx(YouTube, { id: videoId, className: modules_66d8d928.video, videoId: videoId, onEnd: onEnded, opts: {
            width: '100%',
            height: '100%',
            playerVars: {
                autoplay: autoplay ? 1 : 0,
                rel: 0,
                host: 'https://www.youtube-nocookie.com',
            },
        } }));
};

var css = ".VimeoVideoPlayer_module_video__6364f65c511b90aa{width:100%;height:100%;background:var(--loading-background-color) var(--loading-video-image) no-repeat;background-position:center;border-radius:var(--video-player-border-radius)}.VimeoVideoPlayer_module_loaded__6364f65c511b90aa{background-color:transparent}";
var modules_87c59b69 = {"video":"VimeoVideoPlayer_module_video__6364f65c511b90aa","loaded":"VimeoVideoPlayer_module_loaded__6364f65c511b90aa"};
injector_a9ab7c9e(css,{"prepend":true,"attributes":{"data-package":"@clover-growth/video-player@0.8.1"}});

var VimeoVideoPlayer = function (_a) {
    var url = _a.url, autoplay = _a.autoplay;
    var setFeaturesSupported = useVideoPlayer().setFeaturesSupported;
    var _b = useState(false), isLoaded = _b[0], setIsLoaded = _b[1];
    var videoId = isValidUrl(url) ? getVimeoIdFromUrl(url) : url;
    var videoSrc = "https://player.vimeo.com/video/".concat(videoId, "?").concat(autoplay ? "autoplay=1" : "");
    useEffect(function initializeFeaturesSupported() {
        setFeaturesSupported({
            pictureInPicture: false,
            fullscreen: false,
            overlayControls: false,
            inlineControls: false,
        });
    }, []);
    return (jsx("iframe", { frameBorder: 0, className: cx(modules_87c59b69.video, isLoaded && modules_87c59b69.loaded), src: videoSrc, title: "Vimeo video player", allow: "autoplay; fullscreen", allowFullScreen: true, "data-ready": "true", onLoad: function () { return setIsLoaded(true); } }));
};

var VideoPlayerContainer = function (_a) {
    var posterUrl = _a.posterUrl, videoUrl = _a.videoUrl, openInModal = _a.openInModal, playerType = _a.playerType, inlineControls = _a.inlineControls, _b = _a.autoplay, autoplay = _b === void 0 ? false : _b, onEnded = _a.onEnded, posterClassName = _a.posterClassName;
    var _c = useVideoPlayer(), isLoaded = _c.isLoaded, setIsLoaded = _c.setIsLoaded, setIsPlaying = _c.setIsPlaying, setIsSettingsPanelOpen = _c.setIsSettingsPanelOpen, featuresSupported = _c.featuresSupported;
    var hasPoster = Boolean(posterUrl);
    var hidePosterAndPlayVideo = function () {
        setIsLoaded(true);
        setIsPlaying(true);
    };
    var closeAllOverlays = function () {
        setIsSettingsPanelOpen(false);
        openInModal && isLoaded && setIsLoaded(false);
    };
    useEffect(function initializeWhenOpenInModal() {
        if (!openInModal)
            return;
        var handleEsc = function (event) {
            if (event.key === 'Escape') {
                setIsLoaded(false);
            }
        };
        window.addEventListener('keydown', handleEsc);
        return function () { return window.removeEventListener('keydown', handleEsc); };
    }, []);
    return (jsxs("div", __assign({ className: cx(modules_0dd15ba7.videoPlayerContainer, openInModal && isLoaded && modules_0dd15ba7.modal, posterUrl && modules_0dd15ba7.noPoster, playerType === 'youtube' || playerType === 'vimeo' && modules_0dd15ba7.centered), onClick: closeAllOverlays, role: 'presentation' }, { children: [jsx(VideoPoster, __assign({ posterUrl: posterUrl, visible: hasPoster && !isLoaded, handlePlayVideo: hidePosterAndPlayVideo, playerType: playerType, className: posterClassName }, { children: jsxs("div", __assign({ className: modules_0dd15ba7.videoControlsContainer }, { children: [!playerType || playerType === 'native' && jsx(NativeVideoPlayer, { autoplay: autoplay, url: videoUrl, onEnded: onEnded }), playerType === 'youtube' && jsx(YoutubeVideoPlayer, { autoplay: autoplay, url: videoUrl, onEnded: onEnded }), playerType === 'vimeo' && jsx(VimeoVideoPlayer, { autoplay: autoplay, url: videoUrl }), featuresSupported.overlayControls && jsx(OverlayControls, { showCloseButton: hasPoster }), inlineControls === 'over-player' && isLoaded && featuresSupported.inlineControls &&
                            jsx(InlineControls, { position: inlineControls })] })) })), inlineControls !== 'over-player' && isLoaded && featuresSupported.inlineControls &&
                jsx(InlineControls, { position: inlineControls })] })));
};

var VideoPlayerProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), isPlaying = _b[0], setIsPlaying = _b[1];
    var _c = useState(false), isLoaded = _c[0], setIsLoaded = _c[1];
    var _d = useState(false), isFullscreen = _d[0], setIsFullscreen = _d[1];
    var _e = useState(0), seekTime = _e[0], setSeekTime = _e[1];
    var _f = useState(false), isSettingsPanelOpen = _f[0], setIsSettingsPanelOpen = _f[1];
    var _g = useState(false), isPictureInPictureEnabled = _g[0], setIsPictureInPictureEnabled = _g[1];
    var _h = useState(1), playbackSpeed = _h[0], setPlaybackSpeed = _h[1];
    var _j = useState(false), isMuted = _j[0], setIsMuted = _j[1];
    var _k = useState({
        pictureInPicture: false,
        fullscreen: false,
        overlayControls: false,
        inlineControls: false,
    }), featuresSupported = _k[0], setFeaturesSupported = _k[1];
    var _l = useState({
        time: 0,
        duration: 0,
        remaining: 0,
    }), playbackState = _l[0], setPlaybackState = _l[1];
    var videoPlayerState = {
        isPlaying: isPlaying,
        setIsPlaying: setIsPlaying,
        isLoaded: isLoaded,
        setIsLoaded: setIsLoaded,
        isFullscreen: isFullscreen,
        setIsFullscreen: setIsFullscreen,
        playbackState: playbackState,
        setPlaybackState: setPlaybackState,
        seekTime: seekTime,
        setSeekTime: setSeekTime,
        isSettingsPanelOpen: isSettingsPanelOpen,
        setIsSettingsPanelOpen: setIsSettingsPanelOpen,
        isPictureInPictureEnabled: isPictureInPictureEnabled,
        setIsPictureInPictureEnabled: setIsPictureInPictureEnabled,
        playbackSpeed: playbackSpeed,
        setPlaybackSpeed: setPlaybackSpeed,
        setFeaturesSupported: setFeaturesSupported,
        featuresSupported: featuresSupported,
        isMuted: isMuted,
        setIsMuted: setIsMuted,
    };
    return jsx(VideoContext.Provider, __assign({ value: videoPlayerState }, { children: children }));
};

var VideoPlayer = function (conf) {
    var theme = conf.theme, className = conf.className, label = conf.label, videoUrl = conf.videoUrl;
    if (!videoUrl.trim())
        return null;
    var classNames = cx(modules_7d7d7f29.videoPlayer, theme && theme != "default" && modules_7d7d7f29["".concat(theme)], className);
    return jsx("div", __assign({ className: classNames, "aria-label": label }, { children: jsx(VideoPlayerProvider, { children: jsx(VideoPlayerContainer, __assign({}, conf)) }) }));
};

export { VideoPlayer };
